var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3103 9.27586H28.5862V8.93906L24.6765 5.13793H20.3103V9.27586ZM20.3103 10.6552V15.4824C20.9395 14.6451 21.941 14.1034 23.069 14.1034C24.483 14.1034 25.6982 14.9545 26.2303 16.1724H28.5862V10.6552H20.3103ZM18.931 16.1724V3.75862V2.37931H2.37931V16.1724H3.35589C3.888 14.9545 5.10323 14.1034 6.51724 14.1034C7.93125 14.1034 9.14648 14.9545 9.67859 16.1724H18.931ZM20.3103 3.75862H25.2365L29.9655 8.35632V16.1724C29.9655 16.9342 29.348 17.5517 28.5862 17.5517H26.5172C26.5172 19.4562 24.9734 21 23.069 21C21.1645 21 19.6207 19.4562 19.6207 17.5517H9.96552C9.96552 19.4562 8.42167 21 6.51724 21C4.61281 21 3.06897 19.4562 3.06897 17.5517H2.37931C1.61754 17.5517 1 16.9342 1 16.1724V2.37931C1 1.61754 1.61754 1 2.37931 1H18.931C19.6928 1 20.3103 1.61754 20.3103 2.37931V3.75862ZM6.51724 19.6207C7.6599 19.6207 8.58621 18.6944 8.58621 17.5517C8.58621 16.4091 7.6599 15.4828 6.51724 15.4828C5.37458 15.4828 4.44828 16.4091 4.44828 17.5517C4.44828 18.6944 5.37458 19.6207 6.51724 19.6207ZM23.069 19.6207C24.2116 19.6207 25.1379 18.6944 25.1379 17.5517C25.1379 16.4091 24.2116 15.4828 23.069 15.4828C21.9263 15.4828 21 16.4091 21 17.5517C21 18.6944 21.9263 19.6207 23.069 19.6207Z",
    fill: "#607980",
    stroke: "#14344A",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.758facade7445c09d9c34f4625de7dd3.svg";
export { ForwardRef as ReactComponent };